import { createPortal } from 'react-dom';
import { useCreateRootDivElement } from './hooks/useCreateRootDivElement';
import { PortalProps } from './types';

const Portal = ({ children, containerClassName, containerElement }: PortalProps) => {
  const domElement = useCreateRootDivElement({ className: containerClassName, shouldAppendToBody: !containerElement });

  if (containerElement) {
    return createPortal(children, containerElement);
  }

  return domElement ? createPortal(children, domElement) : null;
};

Portal.displayName = 'Portal';

export default Portal;
